@if(templateForPermitForm){
  <div [ngClass]="{'form-group': showLabel}">
    <wm-de-label
      [entity]="entity"
      [for]="entity.templateCode"
      [displayOnly]="true"
      *ngIf="showLabel"
    ></wm-de-label>
    <mat-list>
      <mat-list-item button (click)="open(content)">
        <div class="contact-list-item">
          <wm-common-text
            [data]="{
              text: entity?.selectedContact?.firstName + ' ' + entity?.selectedContact?.lastName
            }"
            class="contact-name">
          </wm-common-text>

          <div class="contact-subtext">
            <wm-common-text
              [data]="{
                text: entity?.selectedContact?.title
              }"
              class="contact-subtext">
            </wm-common-text>

            @if (entity?.selectedContact?.phoneNumber) {
              <wm-common-text
                [data]="{
                  text: '- ' + entity.selectedContact.phoneNumber
                }"
                class="contact-subtext">
              </wm-common-text>
            }
          </div>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
  <ng-template #content >
    <div class="contact-dialog-box">
      <h2 mat-dialog-title class="contact-dialog-header">
        <wm-common-text
          [data]="{
            text: entity?.selectedContact?.firstName + ' ' +
                  entity?.selectedContact?.lastName
          }">
        </wm-common-text>
        <wm-common-button
          class="close-button"
          [data]="{
            variant: 'icon',
            text: 'close'
          }"
          (click)="closeDialog()"
        ></wm-common-button>
      </h2>

      <mat-dialog-content>
        <table class="contact-table">
          <tbody>
            @if (entity?.selectedContact?.title) {
              <tr>
                <th>Title</th>
                <td>
                  <div class="contact-table-input">
                    <wm-common-text
                      [data]="{ text: entity.selectedContact.title }">
                    </wm-common-text>
                  </div>
                </td>
              </tr>
            }

            @if (entity?.selectedContact?.phoneNumber) {
              <tr>
                <th>Phone</th>
                <td>
                  <a [href]="'tel:' + entity.selectedContact.phoneNumber">
                    <div class="contact-table-input contact-text-color">
                      <wm-common-text
                        [data]="{ text: entity.selectedContact.phoneNumber }">
                      </wm-common-text>
                    </div>
                  </a>
                </td>
              </tr>
            }

            @if (entity?.selectedContact?.emailAddress?.email) {
              <tr>
                <th>Email</th>
                <td>
                  <a [href]="'mailto:' + entity.selectedContact.emailAddress.email">
                    <div class="contact-table-input contact-text-color">
                      <wm-common-text
                        [data]="{ text: entity.selectedContact.emailAddress.email }">
                      </wm-common-text>
                    </div>
                  </a>
                </td>
              </tr>
            }

            @if (entity?.selectedContact?.address?.address1) {
              <tr>
                <th>Address</th>
                <td>
                  <mat-list class="contact-table-input address-list">
                    @for (line of addressLines; track $index) {
                      <mat-list-item>
                        <div matListItemLine>
                          <wm-common-text [data]="{ text: line }"></wm-common-text>
                        </div>
                      </mat-list-item>
                    }
                  </mat-list>
                </td>
              </tr>
            }

            @if (entity?.selectedContact?.officeHours) {
              <tr>
                <th>Office Hours</th>
                <td>
                  <div [innerHTML]="getOfficeHours(entity.selectedContact)"></div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-stroked-button (click)="closeDialog()">Close</button>
      </mat-dialog-actions>
    </div>
  </ng-template>
}
@else{
  <div [ngClass]="{'form-group': showLabel}">
    <wm-de-label
      [entity]="entity"
      [for]="entity.templateCode"
      [displayOnly]="true"
      *ngIf="showLabel"
    ></wm-de-label>
    <ul class="list-group">
      <a
        class="list-group-item"
        href="javascript:void(0)"
        (click)="open(content)"
      >
        <div class="bmd-list-group-col">
          <p class="list-group-item-heading">
            {{ entity?.selectedContact?.firstName }}
            {{ entity?.selectedContact?.lastName }}
          </p>
          <p class="list-group-item-text">
            {{ entity?.selectedContact?.title }}
            <span *ngIf="entity?.selectedContact?.phoneNumber">
              - {{ entity?.selectedContact?.phoneNumber }}
            </span>
          </p>
        </div>
      </a>
    </ul>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-contact">
        {{ entity?.selectedContact?.firstName }}
        {{ entity?.selectedContact?.lastName }}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <table class="table table-borderless">
        <tbody>
          <tr *ngIf="entity?.selectedContact?.title">
            <th scope="row">Title</th>
            <td>{{ entity?.selectedContact?.title }}</td>
          </tr>
          <tr *ngIf="entity?.selectedContact?.phoneNumber">
            <th scope="row">Phone</th>
            <td>
              <a href="tel:{{ entity?.selectedContact?.phoneNumber }}">
                {{ entity?.selectedContact?.phoneNumber }}
              </a>
            </td>
          </tr>
          <tr *ngIf="entity?.selectedContact?.emailAddress?.email">
            <th scope="row">Email</th>
            <td>
              <a href="mailto:{{ entity?.selectedContact?.emailAddress.email }}">
                {{ entity?.selectedContact?.emailAddress.email }}
              </a>
            </td>
          </tr>
          <tr *ngIf="entity?.selectedContact?.address?.address1">
            <th scope="row">Address</th>
            <td>
              {{ entity?.selectedContact?.address.address1 }}<br />
              {{ entity?.selectedContact?.address.address2 }}
              <br *ngIf="entity?.selectedContact?.address.address2" />

              {{ entity?.selectedContact?.address.city }},
              {{ entity?.selectedContact?.address.state }}
              {{ entity?.selectedContact?.address.zip }}
            </td>
          </tr>
          <tr *ngIf="entity?.selectedContact?.officeHours">
            <th scope="row">Office Hours</th>
            <td>
              <div [innerHTML]="getOfficeHours(entity.selectedContact)"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark"
        (click)="modal.close('Close click')"
      >
        Close
      </button>
    </div>
  </ng-template>
}
